import React, { Component } from 'react';
import { Tooltip } from 'reactstrap';
import './TooltipSB.css'; // Import the CSS file

class TooltipSB extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tooltipOpen: false
        };
        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        this.setState(prevState => ({
            tooltipOpen: !prevState.tooltipOpen
        }));
    }

    render() {
        const { id, text } = this.props;
        return (
            <div style={{ display: 'inline-block' }}>
        <span id={id} className="question-mark" onMouseOver={this.toggle} onMouseOut={this.toggle}>
          ?
        </span>
                <Tooltip
                    placement="right"
                    isOpen={this.state.tooltipOpen}
                    target={id}
                    toggle={this.toggle}
                >
                    {text}
                </Tooltip>
            </div>
        );
    }
}

export default TooltipSB;
